import * as React from 'react';
import { Account, User } from '@citrite/sf-api';
import type { PiletApi } from '@sharefiledev/sharefile-appshell';
import { LoadingSpinner } from './LoadingSpinner';
import { LocalizationLoader } from './translate';

const Context = React.createContext<AppContext>({
	piletApi: {
		Extension: () => null,
	} as any,
	user: {},
	account: {},
	enableFileBrowser: false, //used in CreateNewRequestListButton.tsx. In other places, directly use task.enableFileBrowser or requestList.enableFileBrowser
});

export interface AppContext {
	piletApi: PiletApi;
	user: User;
	account: Account;
	enableFileBrowser?: boolean; //used in CreateNewRequestListButton.tsx. In other places, directly use task.enableFileBrowser or requestList.enableFileBrowser
	isFrozen?: boolean; //used to determine if the project is in frozen state
}

interface AppContextProviderProps {
	piletApi: PiletApi;
	enableFileBrowser?: boolean; //used in CreateNewRequestListButton.tsx. In other places, directly use task.enableFileBrowser or requestList.enableFileBrowser
	isFrozen?: boolean; //used to determine if the project is in frozen state
}

export function AppContextProvider(
	props: React.PropsWithChildren<AppContextProviderProps>
) {
	return (
		<LocalizationLoader loadingElement={<LoadingSpinner />}>
			{() => (
				<Context.Provider
					value={{
						piletApi: props.piletApi,
						...props.piletApi.sf.piletUserContext.get(),
						enableFileBrowser: props.enableFileBrowser,
						isFrozen: props.isFrozen,
					}}
				>
					{props.children}
				</Context.Provider>
			)}
		</LocalizationLoader>
	);
}

export const useAppContext = () => React.useContext(Context);
